<fc-npo-search-modal-ui
    [npoSearchCallStatus]="npoSearchCallStatus$ | async"
    [npoSearchResults]="npoSearchResults$ | async"
    [pageNumber]="pageNumber$ | async"
    (npoSelected)="npoSelected($event)"
    (npoSearchEmitter)="npoSearched($event)"
    (pageChanged)="pageChanged($event)"></fc-npo-search-modal-ui>
